// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowUpCopper: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7" fill="currentColor">
            <polygon
                fill="currentColor"
                points="283.4 727 282 728.375 286.2 732.5 282 736.625 283.4 738 289 732.5"
                transform="matrix(0 -1 -1 0 738 289)"
            />
        </svg>
    );
};

export default React.memo(IconArrowUpCopper);
